export const checkoutAttemptStatuses = {
  processing: "processing",
  waiting_for_confirmation: "waiting_for_confirmation",
  delayed_confirmation: "delayed_confirmation",
  completed: "completed",
  canceled: "canceled",
  failed: "failed",
} as const;
export type CheckoutAttemptStatus =
  (typeof checkoutAttemptStatuses)[keyof typeof checkoutAttemptStatuses];

export interface PaywallCheckoutAttempt {
  id: string;
  payment_intent_client_secret: string;
  payment_intent_id: string;
  payment_intent_processor_id: string;
  payment_intent_status: string;
  payment_method_type: string;
  status: CheckoutAttemptStatus;
}
